export const USB_EVENTS = {
  STATE_CHANGE: 'usbStateChange',
  FILE_SELECTED: 'usbFileSelected',
} as const;

export type USBEventName = (typeof USB_EVENTS)[keyof typeof USB_EVENTS];

// Possible error types that match our Swift implementation
export enum USBDetectionErrorType {
  MISSING_FILE_PATH = 'missingFilePath',
  INVALID_URL = 'invalidURL',
  SECURITY_ACCESS_DENIED = 'securityAccessDenied',
  DOCUMENT_PICKER_ERROR = 'documentPickerError',
  VIEW_CONTROLLER_UNAVAILABLE = 'viewControllerUnavailable',
  UNEXPECTED = 'unexpected',
}

export interface USBDetectionError extends Error {
  code: USBDetectionErrorType;
  message: string;
}

export interface USBDevice {
  name: string;
  manufacturer: string;
  modelNumber: string;
  serialNumber: string;
  firmwareRevision: string;
  hardwareRevision: string;
  protocols: string[];
}

export interface USBStateChangeEvent {
  isConnected: boolean;
  devices: USBDevice[];
}

export interface USBFileSelectedEvent {
  files: string; // URL string of the selected file
}

export interface FileCheckResult {
  filePath: string;
  fileSize: number;
  lastModified: number;
  exists: boolean;
}

export interface QSenseConfig {
  timeStart?: number;
  timeStop?: number;
  buttonStartEnable?: boolean;
  whitelist?: string[];
  deviceState?: {
    enableOffsetCompensation?: boolean;
    enableMagFieldMapping?: boolean;
    accSensitivity?: 0 | 1 | 2 | 3; // 2g, 16g, 4g, 8g
    gyrSensitivity?: 0 | 1 | 2 | 4 | 6; // 250, 125, 500, 1000, 2000 dps
  };
  dataMode?: 0 | 1 | 2 | 3;
}
